class MathServiceClass {
  positiveOrZero(num) {
    return num < 0 ? 0 : num;
  }

  clamp(num, min, max) {
    return Math.max(Math.min(num, max), min);
  }
}

export const MathService = new MathServiceClass();
